export const pathForPortfolioSlug = (slug) => {
    return `/portfolio${slug}`;
};
